// eslint-disable-next-line import/prefer-default-export
export enum QueryKeys {
  ACCOUNTS = "accounts",
  ADJUSTMENTS = "adjustments",
  APPLICABILITIES = "applicabilities",
  ALLERGIES = "allergies",
  APPOINTMENT_DUPLICATE_PATIENTS = "appointment-duplicate-patients",
  APPOINTMENTS = "appointments",
  APPOINTMENTS_BY_TYPE_PENDING = "appointments-type-pending",
  APPOINTMENTS_BY_TYPE_WAITLISTED = "appointments-type-waitlisted",
  BILLING_SETTINGS = "billing-settings",
  BROADCASTS = "broadcasts",
  CARE_PLANS = "care_plans",
  CHIEF_COMPLAINT = "chief-complaint",
  CHARGE_ITEMS = "charge-items",
  CHARGE_ITEM_DEFINITIONS = "charge-item-definitions",
  COUNT_ENTITIES = "count-entities",
  ENCOUNTERS = "encounters",
  ENCOUNTER_OBSERVATIONS = "encounter-observations",
  AI_NOTES = "ai-notes",
  FREE_OPTIONS = "free-options",
  INSURANCE_PROVIDERS = "insurance-providers",
  INVOICES = "invoices",
  LOCATIONS = "locations",
  MEDICATION = "medication-requests",
  MEDICATION_STATEMENT = "medication-statements",
  MEDICATION_ADMIN_REQUEST = "medication-adminstration-requests",
  MEDICATION_ADMINISTRATION = "medication-adminstrations",
  MEDICATION_REQUEST_ENCOUNTER = "medication-request-encounters",
  NOTIFICATION_PREFERENCES = "notification-preferences",
  OBGYN_QUESTIONNAIRE_HISTORY = "obgyn-questionnaire-history",
  PATIENTS = "patients",
  PAYMENT_RECONCILIATIONS = "payment-reconciliations",
  PRACTITIONERS = "practitioners",
  PREVIOUS_ENCOUNTERS = "previous_encounters",
  PHYSICIAN_ORDERS = "physician-orders",
  PUSH_NOTIFICATIONS = "push-notifications",
  PUSH_NOTIFICATION_COUNTS = "push-notification-counts",
  RESUSCITATION = "resuscitation",
  SERVICES = "services",
  SUBSCRIPTION = "subscription",
  BILLING_LEDGER = "billing-ledger",
  TIERS = "tiers",
  VITALS = "vitals",
}
